import { Collection } from 'vue-mc'
import { fetch } from './MongoCommon'

export default class MongoCollection extends Collection {
  fetch (params, options) { return fetch.call(this, params, options) }
  save (params) { throw new Error('MongoCollection.save() not implemented') }
  delete (params) { throw new Error('MongoCollection.delete() Cannot be implemented') }

  /**
   * @param {Object} snapshot
   *
   * @returns {Array|null} Models from the response.
   */
  getModelsFromResponse (_snapshot) {
    let snapshot = _snapshot

    if (!Array.isArray(snapshot)) {
      snapshot = [ _snapshot ]
    }

    let items = []
    snapshot.forEach(item => {
      let attributes = item
      attributes.id = item._id.toString()

      items.push(attributes)
    })

    return items
  }
}
